import PersonBubble from '../../src/legacy/PersonBubble';
export default PersonBubble;
